<template>
  <div class="pt-5 mt-7">
    <div class="mb-6">
      <h2>{{$t('CONTENT.charts.payments_chart')}}</h2>
    </div>
    <div class="mb-6">
      <button class="b-btn" type="button" @click="recalculate">{{$t('CONTENT.contract.recalculate')}}</button>
    </div>
    <div v-if="error">
      <server-error :error="error"></server-error>
    </div>
    <div v-if="!isHideCharts">
      <ul class="b-tabs__list mb-4">
        <template v-for="(assetComponent, assetComponentIndex) in assetComponentsForCalc">
          <li
            @click="paymentActiveTab=`${assetComponentIndex}`"
            :data-cy="`button-to-show-chart-for-${assetComponentIndex}`"
            class="b-payments__tabs-list-item mr-4"
            :class="{'k-state-active' : assetComponentIndex === 0}"
            :key="`${assetComponentIndex}`"
          >
            <a
              class="b-tabs__list-item-link"
              :class="[ paymentActiveTab == `${assetComponentIndex}` ? 'router-link-active' : '' ]"
            >{{getAssetName(assetComponent.assetId)}}{{getAssetComponentName(assetComponent)}}</a>
          </li>
        </template>
      </ul>
      <template v-for="(assetComponent, assetComponentIndex) in assetComponentsForCalc" class="row">
        <div
          class="b-payments__tabs-content b-tabs"
          :key="`${assetComponentIndex}`"
          v-if="paymentActiveTab == `${assetComponentIndex}`"
        >
          <payment-chart-widget
            :component="assetComponent"
            :isPreview="true"
            :currentVersionId="null"
            />
        </div>
      </template>
      <div class="mt-10">
        <h2>{{$t('CONTENT.charts.liabilityWidgetTitle')}} ({{contractSettingsCurrencyCode}})</h2>
        <liability-widget
          :contractId="contractId"
          :currentVersionId="null"
          :isPreview="true"
          :components="assetComponentsForCalc"
          :allAssets="getAssets"
          :liabilitiesErrors="liabilitiesErrors"
        ></liability-widget>
      </div>
      <div class="mt-10">
        <ul class="b-tabs__list mb-4">
          <template v-for="(assetComponent, assetComponentIndex) in assetComponentsForCalc">
            <li
              @click="liabilityActiveTab=`${assetComponentIndex}`"
              :data-cy="`button-to-show-chart-liabilities-for-${assetComponentIndex}`"
              class="b-payments__tabs-list-item mr-4"
              :class="{'k-state-active' : assetComponentIndex === 0}"
              :key="`${assetComponentIndex}`"
            >
              <a
                class="b-tabs__list-item-link"
                :class="[ liabilityActiveTab == `${assetComponentIndex}` ? 'router-link-active' : '' ]"
              >{{getAssetName(assetComponent.assetId)}}{{getAssetComponentName(assetComponent)}}</a>
            </li>
          </template>
        </ul>
        <template
          v-for="(assetComponent, assetComponentIndex) in assetComponentsForCalc"
          class="row"
        >
          <div
            class="b-payments__tabs-content b-tabs"
            :key="`${assetComponentIndex}`"
            v-if="liabilityActiveTab == `${assetComponentIndex}`"
          >
            <liability-chart-widget
              :component="assetComponent"
              :isPreview="true"
              :contractId="contractId"
              :currentVersionId="null"
            />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    errors:{
     required:false,
    },
  },
  data() {
    return {
      paymentActiveTab: 0,
      liabilityActiveTab: 0,
      assetComponentsForCalc: [],
      contractId: null,
      error: null
    };
  },
  async created() {
    this.getContractPreview();
  },
  computed: {
    ...mapGetters([
      "getAssets",
      "getIsHideCharts",
      "getContractSettings",
      "getCurrentContract"
    ]),
    contractSettingsCurrencyCode() {
      return this.getContractSettings.currencyCode;
    },
    isHideCharts() {
      return this.getIsHideCharts;
    }
  },
  methods: {
    liabilitiesErrors(errors){
      this.errors(errors);
    },
    async getContractPreview() {
      this.error = null;
      try {
        let assetsComponents = this.$store.getters[
          "assetComponentsPlugin/getAllAssetComponents"
        ];
        let contractPreview = await this.$store.dispatch(
          "getContractPreview",
          assetsComponents
        );
        this.assetComponentsForCalc = contractPreview.assetComponents;
        this.contractId = contractPreview.contract.idInDB;
        this.$emit('createContractPreview', contractPreview);
      } catch (e) {
        this.error = e;
      }
    },
    async recalculate() {
      await this.getContractPreview();
      await this.$store.commit("SET_VIEW_STATE_OF_CHARTS", false);
    },
    getAssetComponentName(component) {
      if (component.name !== null) {
        return ` - ${component.name}`;
      }
    },
    getAssetName(assetId) {
      for (let i = 0; i < this.getAssets.length; i++) {
        if (this.getAssets[i].idInDB === assetId) {
          return this.getAssets[i].name;
        }
      }
    },
  }
};
</script>
